// html5 video
try {
    let video = document.querySelector("#video");

    // play video if on desktop
    if(screen.width > 600){
        video.querySelector('source').setAttribute('src', video.querySelector('source').getAttribute('data-src'));
        video.load();
        
        // slow down video
        video.playbackRate = 0.5;
    }
} catch (error) {}

// fade out loader
$('.page-loader').fadeOut();

// contact form 7
let wpcf7 = document.querySelector('.wpcf7');
if(wpcf7){
    $('.wpcf7-submit').on('click',function(){
        setTimeout(() => {
            $(this).attr('disabled', true);
        }, 10);
    });
    wpcf7.addEventListener('wpcf7submit', function(event) {
    $('.wpcf7-submit').attr('disabled', false);
    }, false);
}

$("header .navbar-toggler").click(function(){
    $(this).toggleClass('active');
    $(".navbar").toggleClass("show");
    $("body").toggleClass("menu-open");
});

$('.navbar-nav li a,.navbar-brand').on('click', function(e) {
    $('#navbarSupportedContent').collapse('hide');
    $("body").removeClass("menu-open");
    $(".navbar").removeClass("show");
});

$( '.navbar .navbar-nav a' ).on( 'click', function () {
    $( '.navbar .navbar-nav' ).find( 'li.active' ).removeClass( 'active' );
    $( this ).parent( 'li' ).addClass( 'active' );
});

$('.navbar-brand').on('click', function() {
    $( '.navbar .navbar-nav' ).find( 'li.active' ).removeClass( 'active' );
});

// stickyHeader
$(function () {
    var shrinkHeader = 120;
    $(window).on('scroll', function () {
        var scroll = getCurrentScroll();
        if (scroll >= 120) {
            $('header').addClass('sticky');
        } else {
            $('header').removeClass('sticky');
        }
    });
    function getCurrentScroll() {
        return window.pageYOffset || document.documentElement.scrollTop;
    }
});

// handle page load with anchor point
if(location.hash){
    $('header').addClass('sticky');
    setTimeout(function() {
        window.scrollTo(0, $(location.hash).offset().top - $('header').height() + 1);
    }, 1);
}

// stick header if page load it not at the top
if($(window).scrollTop() > 120){
    $('header').addClass('sticky');
}

//Smooth Section Scrolling
$("a[href^='#']").on('click', function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
        let target = $(this.hash);

        if (target.length) {
            $('html,body').animate({
                scrollTop: (target.offset().top - $('header').height()) + 1
            }, screen.width < 600 ? 0:800);
            return false;
        }
    }
});

// activate anchor navigation links on scroll
$(document).on('scroll', function(){
    $('section').each(function() {
        let bounding = this.getBoundingClientRect();
        let isActive = (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        )
        if(isActive) {
            $( '.navbar .navbar-nav' ).find( 'li.active' ).removeClass( 'active' );
            $( 'a[href="#' + this.id + '"]' ).parent( 'li' ).addClass( 'active' );
        }
    });
});

// AOS animation
AOS.init({
    duration: 1500,
});

// Parallax
new simpleParallax(document.querySelectorAll('.parallax-image img'), {
    customWrapper: '.parallax-image',
    orientation: 'down',
});